const { code, hasBookingSalesRole } = require('./booking-detail')

const definitions = [
  { code: 'confirm', name: 'Confirm booking', icon: 'pi-check-circle', tone: 'default', description: 'Send passenger details to the airline and confirm the booking.', explanation: 'Send the completed passenger details to the airline and confirm this booking.' },
  { code: 'issue-ticket', name: 'Issue ticket', icon: 'pi-ticket', tone: 'default', description: 'Request ticket issuance for this booking.', explanation: 'Request ticket issuance for all passengers in this booking.' },
  { code: 'cancel', name: 'Cancel booking', icon: 'pi-times-circle', tone: 'danger', description: 'Cancel this booking with the airline.', explanation: 'Cancel this booking with the airline. All flights and all passengers will be cancelled.' },
  { code: 'refresh', name: 'Refresh booking', icon: 'pi-refresh', tone: 'default', description: 'Update the booking with the latest status and details from the airline.', explanation: 'Retrieve the latest booking details from the airline and update this booking.' }
]

function bookingAutoActions(booking, groups) {
  if (!booking || code(booking.booking_mode) !== 'aerocrs' || !hasBookingSalesRole(groups)) return []
  const status = code(booking.status)
  return definitions.filter(action => {
    if (action.code === 'confirm') return status === 'held'
    if (action.code === 'issue-ticket') return status === 'confirmed'
    if (action.code === 'cancel') return Boolean(status) && status !== 'cancelled'
    return ['confirmed', 'ticketed'].includes(status)
  }).map(action => {
    const incomplete = action.code === 'confirm' && !(booking.passengers_assignment && booking.passengers_assignment.completed)
    const unavailable = action.code === 'refresh'
    return {
      ...action,
      disabled: incomplete || unavailable,
      description: incomplete ? 'Complete passenger assignment to confirm this booking.' : action.description,
      disabledReason: unavailable ? 'Refresh booking is not available yet.' : incomplete ? 'Complete passenger assignment to confirm this booking.' : ''
    }
  })
}

module.exports = { bookingAutoActions }
